module.exports = __webpack_public_path__ + "static/ojp-3e077ba6f59f2603838f3a6801bb9b14.jpg";